import React from "react";
import { ArrowRight, CirclePlay } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnderstandYourAudience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="10215" id="buy-digital-services-with-crypto" className="dark bg-background text-foreground relative overflow-hidden min-h-[85vh] flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        {}
        <div className="absolute -top-[20%] -right-[10%] w-[800px] h-[800px] rounded-full bg-[radial-gradient(circle,hsla(180,100%,50%,0.12)_0%,transparent_70%)] blur-3xl animate-[spin_30s_linear_infinite] opacity-40 mix-blend-screen" />
        
        {}
        <div className="absolute -bottom-[20%] -left-[10%] w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,hsla(240,5%,64.9%,0.08)_0%,transparent_70%)] blur-3xl opacity-30" />

        {}
        <div className="absolute inset-0 z-10 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)`,
        backgroundSize: '60px 60px',
        maskImage: 'radial-gradient(circle at center, black 30%, transparent 100%)'
      }} />
      </div>

      {}
      <div ref={ref} className={`relative z-20 max-w-5xl mx-auto text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-primary/10 border border-primary/20 text-primary text-xs font-mono mb-8 backdrop-blur-sm tracking-wider uppercase">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
          </span>
          Secure Crypto Checkout v3.0
        </div>

        {}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold font-default tracking-tighter mb-8 leading-[1.05]">
          <span className="block text-foreground">Buy digital services</span>
          <span className="bg-gradient-to-r from-foreground via-foreground/80 to-muted-foreground bg-clip-text text-transparent">
            with crypto.
          </span>
        </h1>

        {}
        <p className="text-lg sm:text-xl font-default text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
          Privacy-first, borderless access. Unlock premium SaaS tools, global eSIM connectivity, and high-performance VPS instantly using your preferred digital assets.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="h-14 px-8 text-lg rounded-sm font-default bg-primary text-primary-foreground hover:opacity-90 hover:scale-[1.02] transition-all duration-300 shadow-[0_0_30px_rgba(0,255,255,0.2)] border-0">
            <Link to="#">
              Browse Services
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-sm font-default border-border hover:bg-white/5 hover:text-foreground hover:border-primary/50 transition-all duration-300 backdrop-blur-sm">
            <Link to="#">
              <CirclePlay className="mr-2 h-5 w-5" />
              How It Works
            </Link>
          </Button>
        </div>

        {}
        <div className="mt-20 pt-10 border-t border-border/20 flex flex-col items-center gap-6 opacity-40">
          <p className="text-xs font-mono text-muted-foreground uppercase tracking-[0.3em]">Supported Networks</p>
          <div className="flex items-center gap-10 grayscale hover:grayscale-0 transition-all duration-500">
             {}
             <span className="text-sm font-mono font-bold text-foreground/70 tracking-tighter">BTC_NETWORK</span>
             <span className="text-sm font-mono font-bold text-foreground/70 tracking-tighter">ETH_MAINNET</span>
             <span className="text-sm font-mono font-bold text-foreground/70 tracking-tighter">SOL_CHAIN</span>
             <span className="text-sm font-mono font-bold text-foreground/70 tracking-tighter">USDT_TRC20</span>
          </div>
        </div>
      </div>
    </section>;
}